import React from "react"

const Newsletter = ({ newsletterId }) => {
  return (
    <div className="w-full flex grow">
      <iframe 
        src={`${process.env.API_BASE_URL}/newsletters/${newsletterId}`}
        className="w-full"
        title="Newsletter content"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
      />
    </div>
  )
}

export default Newsletter 